import { InstMunicipalityField } from "../components/InstMunicipalityFiels";
import { InstIdTypeField } from "../components/InstIdTypeField";
import { InstIdField } from "../components/InstIdField";
import { InstFullNameInput } from "../components/InstFullNameInput";
import { InstEmailInput } from "../components/InstEmailInputs";

/**
 * Agrupa los componentes que conforman los campos del formulario
 * de acceso institucional tipo FormMunicipality.
 *
 * Este objeto facilita la importación y el acceso centralizado a los
 * distintos campos del formulario desde el componente principal,
 * permitiendo referenciarlos mediante `MunicipalityFormFields`.
 *
 * @constant
 * @type {Object}
 * @property {React.ComponentType} InstMunicipalityField - Campo para ingresar el municipio.
 * @property {React.ComponentType} InstIdTypeField - Campo para seleccionar el tipo de documento.
 * @property {React.ComponentType} InstIdField - Campo para ingresar el número de documento.
 * @property {React.ComponentType} InstFullNameInput - Campo para ingresar el nombre y apellido.
 * @property {React.ComponentType} InstEmailInput - Campo para ingresar el correo electrónico.
 */
export const MunicipalityFormFields = {
    InstMunicipalityField,
    InstIdTypeField,
    InstIdField,
    InstFullNameInput,
    InstEmailInput
}